var _marked = /*#__PURE__*/_regeneratorRuntime.mark(combineWalkers),
    _marked2 = /*#__PURE__*/_regeneratorRuntime.mark(convertToMinimalFlatRanges);

import _regeneratorRuntime from "@babel/runtime/regenerator";

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e2) { throw _e2; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e3) { didErr = true; err = _e3; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/**
 * @license Copyright (c) 2003-2021, CKSource - Frederico Knabben. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

/**
 * @module engine/model/schema
 */
import CKEditorError from '@ckeditor/ckeditor5-utils/src/ckeditorerror';
import ObservableMixin from '@ckeditor/ckeditor5-utils/src/observablemixin';
import mix from '@ckeditor/ckeditor5-utils/src/mix';
import Range from './range';
import Position from './position';
import Element from './element';
import Text from './text';
import TreeWalker from './treewalker';
/**
 * The model's schema. It defines allowed and disallowed structures of nodes as well as nodes' attributes.
 * The schema is usually defined by features and based on them the editing framework and features
 * make decisions how to change and process the model.
 *
 * The instance of schema is available in {@link module:engine/model/model~Model#schema `editor.model.schema`}.
 *
 * Read more about the schema in:
 *
 * * {@glink framework/guides/architecture/editing-engine#schema Schema} section of the
 * {@glink framework/guides/architecture/editing-engine Introduction to the Editing engine architecture}.
 * * {@glink framework/guides/deep-dive/schema Schema deep dive} guide.
 *
 * @mixes module:utils/observablemixin~ObservableMixin
 */

var Schema = /*#__PURE__*/function () {
  /**
   * Creates schema instance.
   */
  function Schema() {
    var _this = this;

    _classCallCheck(this, Schema);

    this._sourceDefinitions = {};
    /**
     * A dictionary containing attribute properties.
     *
     * @private
     * @member {Object.<String,String>}
     */

    this._attributeProperties = {};
    this.decorate('checkChild');
    this.decorate('checkAttribute');
    this.on('checkAttribute', function (evt, args) {
      args[0] = new SchemaContext(args[0]);
    }, {
      priority: 'highest'
    });
    this.on('checkChild', function (evt, args) {
      args[0] = new SchemaContext(args[0]);
      args[1] = _this.getDefinition(args[1]);
    }, {
      priority: 'highest'
    });
  }
  /**
   * Registers schema item. Can only be called once for every item name.
   *
   *		schema.register( 'paragraph', {
   *			inheritAllFrom: '$block'
   *		} );
   *
   * @param {String} itemName
   * @param {module:engine/model/schema~SchemaItemDefinition} definition
   */


  _createClass(Schema, [{
    key: "register",
    value: function register(itemName, definition) {
      if (this._sourceDefinitions[itemName]) {
        /**
         * A single item cannot be registered twice in the schema.
         *
         * This situation may happen when:
         *
         * * Two or more plugins called {@link #register `register()`} with the same name. This will usually mean that
         * there is a collision between plugins which try to use the same element in the model. Unfortunately,
         * the only way to solve this is by modifying one of these plugins to use a unique model element name.
         * * A single plugin was loaded twice. This happens when it is installed by npm/yarn in two versions
         * and usually means one or more of the following issues:
         *     * a version mismatch (two of your dependencies require two different versions of this plugin),
         *     * incorrect imports (this plugin is somehow imported twice in a way which confuses webpack),
         *     * mess in `node_modules/` (`rm -rf node_modules/` may help).
         *
         * **Note:** Check the logged `itemName` to better understand which plugin was duplicated/conflicting.
         *
         * @param itemName The name of the model element that is being registered twice.
         * @error schema-cannot-register-item-twice
         */
        throw new CKEditorError('schema-cannot-register-item-twice', this, {
          itemName: itemName
        });
      }

      this._sourceDefinitions[itemName] = [Object.assign({}, definition)];

      this._clearCache();
    }
    /**
     * Extends a {@link #register registered} item's definition.
     *
     * Extending properties such as `allowIn` will add more items to the existing properties,
     * while redefining properties such as `isBlock` will override the previously defined ones.
     *
     *		schema.register( 'foo', {
     *			allowIn: '$root',
     *			isBlock: true;
     *		} );
     *		schema.extend( 'foo', {
     *			allowIn: 'blockQuote',
     *			isBlock: false
     *		} );
     *
     *		schema.getDefinition( 'foo' );
     *		//	{
     *		//		allowIn: [ '$root', 'blockQuote' ],
     *		// 		isBlock: false
     *		//	}
     *
     * @param {String} itemName
     * @param {module:engine/model/schema~SchemaItemDefinition} definition
     */

  }, {
    key: "extend",
    value: function extend(itemName, definition) {
      if (!this._sourceDefinitions[itemName]) {
        /**
         * Cannot extend an item which was not registered yet.
         *
         * This error happens when a plugin tries to extend the schema definition of an item which was not
         * {@link #register registered} yet.
         *
         * @param itemName The name of the model element which is being extended.
         * @error schema-cannot-extend-missing-item
         */
        throw new CKEditorError('schema-cannot-extend-missing-item', this, {
          itemName: itemName
        });
      }

      this._sourceDefinitions[itemName].push(Object.assign({}, definition));

      this._clearCache();
    }
    /**
     * Returns data of all registered items.
     *
     * This method should normally be used for reflection purposes (e.g. defining a clone of a certain element,
     * checking a list of all block elements, etc).
     * Use specific methods (such as {@link #checkChild `checkChild()`} or {@link #isLimit `isLimit()`})
     * in other cases.
     *
     * @returns {Object.<String,module:engine/model/schema~SchemaCompiledItemDefinition>}
     */

  }, {
    key: "getDefinitions",
    value: function getDefinitions() {
      if (!this._compiledDefinitions) {
        this._compile();
      }

      return this._compiledDefinitions;
    }
    /**
     * Returns a definition of the given item or `undefined` if an item is not registered.
     *
     * This method should normally be used for reflection purposes (e.g. defining a clone of a certain element,
     * checking a list of all block elements, etc).
     * Use specific methods (such as {@link #checkChild `checkChild()`} or {@link #isLimit `isLimit()`})
     * in other cases.
     *
     * @param {module:engine/model/item~Item|module:engine/model/schema~SchemaContextItem|String} item
     * @returns {module:engine/model/schema~SchemaCompiledItemDefinition}
     */

  }, {
    key: "getDefinition",
    value: function getDefinition(item) {
      var itemName;

      if (typeof item == 'string') {
        itemName = item;
      } else if (item.is && (item.is('$text') || item.is('$textProxy'))) {
        itemName = '$text';
      } // Element or module:engine/model/schema~SchemaContextItem.
      else {
          itemName = item.name;
        }

      return this.getDefinitions()[itemName];
    }
    /**
     * Returns `true` if the given item is registered in the schema.
     *
     *		schema.isRegistered( 'paragraph' ); // -> true
     *		schema.isRegistered( editor.model.document.getRoot() ); // -> true
     *		schema.isRegistered( 'foo' ); // -> false
     *
     * @param {module:engine/model/item~Item|module:engine/model/schema~SchemaContextItem|String} item
    	 * @returns {Boolean}
     */

  }, {
    key: "isRegistered",
    value: function isRegistered(item) {
      return !!this.getDefinition(item);
    }
    /**
     * Returns `true` if the given item is defined to be
     * a block by the {@link module:engine/model/schema~SchemaItemDefinition}'s `isBlock` property.
     *
     *		schema.isBlock( 'paragraph' ); // -> true
     *		schema.isBlock( '$root' ); // -> false
     *
     *		const paragraphElement = writer.createElement( 'paragraph' );
     *		schema.isBlock( paragraphElement ); // -> true
     *
     * See the {@glink framework/guides/deep-dive/schema#block-elements Block elements} section of the Schema deep dive
     * guide for more details.
     *
     * @param {module:engine/model/item~Item|module:engine/model/schema~SchemaContextItem|String} item
     	 * @returns {Boolean}
     */

  }, {
    key: "isBlock",
    value: function isBlock(item) {
      var def = this.getDefinition(item);
      return !!(def && def.isBlock);
    }
    /**
     * Returns `true` if the given item should be treated as a limit element.
     *
     * It considers an item to be a limit element if its
     * {@link module:engine/model/schema~SchemaItemDefinition}'s
     * {@link module:engine/model/schema~SchemaItemDefinition#isLimit `isLimit`} or
     * {@link module:engine/model/schema~SchemaItemDefinition#isObject `isObject`} property
     * was set to `true`.
     *
     *		schema.isLimit( 'paragraph' ); // -> false
     *		schema.isLimit( '$root' ); // -> true
     *		schema.isLimit( editor.model.document.getRoot() ); // -> true
     *		schema.isLimit( 'imageBlock' ); // -> true
     *
     * See the {@glink framework/guides/deep-dive/schema#limit-elements Limit elements} section of the Schema deep dive
     * guide for more details.
     *
     * @param {module:engine/model/item~Item|module:engine/model/schema~SchemaContextItem|String} item
     	 * @returns {Boolean}
     */

  }, {
    key: "isLimit",
    value: function isLimit(item) {
      var def = this.getDefinition(item);

      if (!def) {
        return false;
      }

      return !!(def.isLimit || def.isObject);
    }
    /**
     * Returns `true` if the given item should be treated as an object element.
     *
     * It considers an item to be an object element if its
     * {@link module:engine/model/schema~SchemaItemDefinition}'s
     * {@link module:engine/model/schema~SchemaItemDefinition#isObject `isObject`} property
     * was set to `true`.
     *
     *		schema.isObject( 'paragraph' ); // -> false
     *		schema.isObject( 'imageBlock' ); // -> true
     *
     *		const imageElement = writer.createElement( 'imageBlock' );
     *		schema.isObject( imageElement ); // -> true
     *
     * See the {@glink framework/guides/deep-dive/schema#object-elements Object elements} section of the Schema deep dive
     * guide for more details.
     *
     * @param {module:engine/model/item~Item|module:engine/model/schema~SchemaContextItem|String} item
     	 * @returns {Boolean}
     */

  }, {
    key: "isObject",
    value: function isObject(item) {
      var def = this.getDefinition(item);

      if (!def) {
        return false;
      } // Note: Check out the implementation of #isLimit(), #isSelectable(), and #isContent()
      // to understand why these three constitute an object.


      return !!(def.isObject || def.isLimit && def.isSelectable && def.isContent);
    }
    /**
     * Returns `true` if the given item is defined to be
     * an inline element by the {@link module:engine/model/schema~SchemaItemDefinition}'s `isInline` property.
     *
     *		schema.isInline( 'paragraph' ); // -> false
     *		schema.isInline( 'softBreak' ); // -> true
     *
     *		const text = writer.createText( 'foo' );
     *		schema.isInline( text ); // -> true
     *
     * See the {@glink framework/guides/deep-dive/schema#inline-elements Inline elements} section of the Schema deep dive
     * guide for more details.
     *
     * @param {module:engine/model/item~Item|module:engine/model/schema~SchemaContextItem|String} item
     * @returns {Boolean}
     */

  }, {
    key: "isInline",
    value: function isInline(item) {
      var def = this.getDefinition(item);
      return !!(def && def.isInline);
    }
    /**
     * Returns `true` if the given item is defined to be
     * a selectable element by the {@link module:engine/model/schema~SchemaItemDefinition}'s `isSelectable` property.
     *
     *		schema.isSelectable( 'paragraph' ); // -> false
     *		schema.isSelectable( 'heading1' ); // -> false
     *		schema.isSelectable( 'imageBlock' ); // -> true
     *		schema.isSelectable( 'tableCell' ); // -> true
     *
     *		const text = writer.createText( 'foo' );
     *		schema.isSelectable( text ); // -> false
     *
     * See the {@glink framework/guides/deep-dive/schema#selectable-elements Selectable elements section} of the Schema deep dive
     * guide for more details.
     *
     * @param {module:engine/model/item~Item|module:engine/model/schema~SchemaContextItem|String} item
     * @returns {Boolean}
     */

  }, {
    key: "isSelectable",
    value: function isSelectable(item) {
      var def = this.getDefinition(item);

      if (!def) {
        return false;
      }

      return !!(def.isSelectable || def.isObject);
    }
    /**
     * Returns `true` if the given item is defined to be
     * a content by the {@link module:engine/model/schema~SchemaItemDefinition}'s `isContent` property.
     *
     *		schema.isContent( 'paragraph' ); // -> false
     *		schema.isContent( 'heading1' ); // -> false
     *		schema.isContent( 'imageBlock' ); // -> true
     *		schema.isContent( 'horizontalLine' ); // -> true
     *
     *		const text = writer.createText( 'foo' );
     *		schema.isContent( text ); // -> true
     *
     * See the {@glink framework/guides/deep-dive/schema#content-elements Content elements section} of the Schema deep dive
     * guide for more details.
     *
     * @param {module:engine/model/item~Item|module:engine/model/schema~SchemaContextItem|String} item
     * @returns {Boolean}
     */

  }, {
    key: "isContent",
    value: function isContent(item) {
      var def = this.getDefinition(item);

      if (!def) {
        return false;
      }

      return !!(def.isContent || def.isObject);
    }
    /**
     * Checks whether the given node (`child`) can be a child of the given context.
     *
     *		schema.checkChild( model.document.getRoot(), paragraph ); // -> false
     *
     *		schema.register( 'paragraph', {
     *			allowIn: '$root'
     *		} );
     *		schema.checkChild( model.document.getRoot(), paragraph ); // -> true
     *
     * Note: When verifying whether the given node can be a child of the given context, the
     * schema also verifies the entire context &mdash; from its root to its last element. Therefore, it is possible
     * for `checkChild()` to return `false` even though the context's last element can contain the checked child.
     * It happens if one of the context's elements does not allow its child.
     *
     * @fires checkChild
     * @param {module:engine/model/schema~SchemaContextDefinition} context The context in which the child will be checked.
     * @param {module:engine/model/node~Node|String} def The child to check.
     * @returns {Boolean}
     */

  }, {
    key: "checkChild",
    value: function checkChild(context, def) {
      // Note: context and child are already normalized here to a SchemaContext and SchemaCompiledItemDefinition.
      if (!def) {
        return false;
      }

      return this._checkContextMatch(def, context);
    }
    /**
     * Checks whether the given attribute can be applied in the given context (on the last
     * item of the context).
     *
     *		schema.checkAttribute( textNode, 'bold' ); // -> false
     *
     *		schema.extend( '$text', {
     *			allowAttributes: 'bold'
     *		} );
     *		schema.checkAttribute( textNode, 'bold' ); // -> true
     *
     * @fires checkAttribute
     * @param {module:engine/model/schema~SchemaContextDefinition} context The context in which the attribute will be checked.
     * @param {String} attributeName
     * @returns {Boolean}
     */

  }, {
    key: "checkAttribute",
    value: function checkAttribute(context, attributeName) {
      var def = this.getDefinition(context.last);

      if (!def) {
        return false;
      }

      return def.allowAttributes.includes(attributeName);
    }
    /**
     * Checks whether the given element (`elementToMerge`) can be merged with the specified base element (`positionOrBaseElement`).
     *
     * In other words &mdash; whether `elementToMerge`'s children {@link #checkChild are allowed} in the `positionOrBaseElement`.
     *
     * This check ensures that elements merged with {@link module:engine/model/writer~Writer#merge `Writer#merge()`}
     * will be valid.
     *
     * Instead of elements, you can pass the instance of the {@link module:engine/model/position~Position} class as the
     * `positionOrBaseElement`. It means that the elements before and after the position will be checked whether they can be merged.
     *
     * @param {module:engine/model/position~Position|module:engine/model/element~Element} positionOrBaseElement The position or base
     * element to which the `elementToMerge` will be merged.
     * @param {module:engine/model/element~Element} elementToMerge The element to merge. Required if `positionOrBaseElement` is an element.
     * @returns {Boolean}
     */

  }, {
    key: "checkMerge",
    value: function checkMerge(positionOrBaseElement) {
      var elementToMerge = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

      if (positionOrBaseElement instanceof Position) {
        var nodeBefore = positionOrBaseElement.nodeBefore;
        var nodeAfter = positionOrBaseElement.nodeAfter;

        if (!(nodeBefore instanceof Element)) {
          /**
           * The node before the merge position must be an element.
           *
           * @error schema-check-merge-no-element-before
           */
          throw new CKEditorError('schema-check-merge-no-element-before', this);
        }

        if (!(nodeAfter instanceof Element)) {
          /**
           * The node after the merge position must be an element.
           *
           * @error schema-check-merge-no-element-after
           */
          throw new CKEditorError('schema-check-merge-no-element-after', this);
        }

        return this.checkMerge(nodeBefore, nodeAfter);
      }

      var _iterator = _createForOfIteratorHelper(elementToMerge.getChildren()),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var child = _step.value;

          if (!this.checkChild(positionOrBaseElement, child)) {
            return false;
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      return true;
    }
    /**
     * Allows registering a callback to the {@link #checkChild} method calls.
     *
     * Callbacks allow you to implement rules which are not otherwise possible to achieve
     * by using the declarative API of {@link module:engine/model/schema~SchemaItemDefinition}.
     * For example, by using this method you can disallow elements in specific contexts.
     *
     * This method is a shorthand for using the {@link #event:checkChild} event. For even better control,
     * you can use that event instead.
     *
     * Example:
     *
     *		// Disallow heading1 directly inside a blockQuote.
     *		schema.addChildCheck( ( context, childDefinition ) => {
     *			if ( context.endsWith( 'blockQuote' ) && childDefinition.name == 'heading1' ) {
     *				return false;
     *			}
     *		} );
     *
     * Which translates to:
     *
     *		schema.on( 'checkChild', ( evt, args ) => {
     *			const context = args[ 0 ];
     *			const childDefinition = args[ 1 ];
     *
     *			if ( context.endsWith( 'blockQuote' ) && childDefinition && childDefinition.name == 'heading1' ) {
     *				// Prevent next listeners from being called.
     *				evt.stop();
     *				// Set the checkChild()'s return value.
     *				evt.return = false;
     *			}
     *		}, { priority: 'high' } );
     *
     * @param {Function} callback The callback to be called. It is called with two parameters:
     * {@link module:engine/model/schema~SchemaContext} (context) instance and
     * {@link module:engine/model/schema~SchemaCompiledItemDefinition} (child-to-check definition).
     * The callback may return `true/false` to override `checkChild()`'s return value. If it does not return
     * a boolean value, the default algorithm (or other callbacks) will define `checkChild()`'s return value.
     */

  }, {
    key: "addChildCheck",
    value: function addChildCheck(callback) {
      this.on('checkChild', function (evt, _ref) {
        var _ref2 = _slicedToArray(_ref, 2),
            ctx = _ref2[0],
            childDef = _ref2[1];

        // checkChild() was called with a non-registered child.
        // In 99% cases such check should return false, so not to overcomplicate all callbacks
        // don't even execute them.
        if (!childDef) {
          return;
        }

        var retValue = callback(ctx, childDef);

        if (typeof retValue == 'boolean') {
          evt.stop();
          evt.return = retValue;
        }
      }, {
        priority: 'high'
      });
    }
    /**
     * Allows registering a callback to the {@link #checkAttribute} method calls.
     *
     * Callbacks allow you to implement rules which are not otherwise possible to achieve
     * by using the declarative API of {@link module:engine/model/schema~SchemaItemDefinition}.
     * For example, by using this method you can disallow attribute if node to which it is applied
     * is contained within some other element (e.g. you want to disallow `bold` on `$text` within `heading1`).
     *
     * This method is a shorthand for using the {@link #event:checkAttribute} event. For even better control,
     * you can use that event instead.
     *
     * Example:
     *
     *		// Disallow bold on $text inside heading1.
     *		schema.addAttributeCheck( ( context, attributeName ) => {
     *			if ( context.endsWith( 'heading1 $text' ) && attributeName == 'bold' ) {
     *				return false;
     *			}
     *		} );
     *
     * Which translates to:
     *
     *		schema.on( 'checkAttribute', ( evt, args ) => {
     *			const context = args[ 0 ];
     *			const attributeName = args[ 1 ];
     *
     *			if ( context.endsWith( 'heading1 $text' ) && attributeName == 'bold' ) {
     *				// Prevent next listeners from being called.
     *				evt.stop();
     *				// Set the checkAttribute()'s return value.
     *				evt.return = false;
     *			}
     *		}, { priority: 'high' } );
     *
     * @param {Function} callback The callback to be called. It is called with two parameters:
     * {@link module:engine/model/schema~SchemaContext} (context) instance and attribute name.
     * The callback may return `true/false` to override `checkAttribute()`'s return value. If it does not return
     * a boolean value, the default algorithm (or other callbacks) will define `checkAttribute()`'s return value.
     */

  }, {
    key: "addAttributeCheck",
    value: function addAttributeCheck(callback) {
      this.on('checkAttribute', function (evt, _ref3) {
        var _ref4 = _slicedToArray(_ref3, 2),
            ctx = _ref4[0],
            attributeName = _ref4[1];

        var retValue = callback(ctx, attributeName);

        if (typeof retValue == 'boolean') {
          evt.stop();
          evt.return = retValue;
        }
      }, {
        priority: 'high'
      });
    }
    /**
     * This method allows assigning additional metadata to the model attributes. For example,
     * {@link module:engine/model/schema~AttributeProperties `AttributeProperties#isFormatting` property} is
     * used to mark formatting attributes (like `bold` or `italic`).
     *
     *		// Mark bold as a formatting attribute.
     *		schema.setAttributeProperties( 'bold', {
     *			isFormatting: true
     *		} );
     *
     *		// Override code not to be considered a formatting markup.
     *		schema.setAttributeProperties( 'code', {
     *			isFormatting: false
     *		} );
     *
     * Properties are not limited to members defined in the
     * {@link module:engine/model/schema~AttributeProperties `AttributeProperties` type} and you can also use custom properties:
     *
     *		schema.setAttributeProperties( 'blockQuote', {
     *			customProperty: 'value'
     *		} );
     *
     * Subsequent calls with the same attribute will extend its custom properties:
     *
     *		schema.setAttributeProperties( 'blockQuote', {
     *			one: 1
     *		} );
     *
     *		schema.setAttributeProperties( 'blockQuote', {
     *			two: 2
     *		} );
     *
     *		console.log( schema.getAttributeProperties( 'blockQuote' ) );
     *		// Logs: { one: 1, two: 2 }
     *
     * @param {String} attributeName A name of the attribute to receive the properties.
     * @param {module:engine/model/schema~AttributeProperties} properties A dictionary of properties.
     */

  }, {
    key: "setAttributeProperties",
    value: function setAttributeProperties(attributeName, properties) {
      this._attributeProperties[attributeName] = Object.assign(this.getAttributeProperties(attributeName), properties);
    }
    /**
     * Returns properties associated with a given model attribute. See {@link #setAttributeProperties `setAttributeProperties()`}.
     *
     * @param {String} attributeName A name of the attribute.
     * @returns {module:engine/model/schema~AttributeProperties}
     */

  }, {
    key: "getAttributeProperties",
    value: function getAttributeProperties(attributeName) {
      return this._attributeProperties[attributeName] || {};
    }
    /**
     * Returns the lowest {@link module:engine/model/schema~Schema#isLimit limit element} containing the entire
     * selection/range/position or the root otherwise.
     *
     * @param {module:engine/model/selection~Selection|module:engine/model/documentselection~DocumentSelection|
     * module:engine/model/range~Range|module:engine/model/position~Position} selectionOrRangeOrPosition
     * The selection/range/position to check.
     * @returns {module:engine/model/element~Element} The lowest limit element containing
     * the entire `selectionOrRangeOrPosition`.
     */

  }, {
    key: "getLimitElement",
    value: function getLimitElement(selectionOrRangeOrPosition) {
      var element;

      if (selectionOrRangeOrPosition instanceof Position) {
        element = selectionOrRangeOrPosition.parent;
      } else {
        var ranges = selectionOrRangeOrPosition instanceof Range ? [selectionOrRangeOrPosition] : Array.from(selectionOrRangeOrPosition.getRanges()); // Find the common ancestor for all selection's ranges.

        element = ranges.reduce(function (element, range) {
          var rangeCommonAncestor = range.getCommonAncestor();

          if (!element) {
            return rangeCommonAncestor;
          }

          return element.getCommonAncestor(rangeCommonAncestor, {
            includeSelf: true
          });
        }, null);
      }

      while (!this.isLimit(element)) {
        if (element.parent) {
          element = element.parent;
        } else {
          break;
        }
      }

      return element;
    }
    /**
     * Checks whether the attribute is allowed in selection:
     *
     * * if the selection is not collapsed, then checks if the attribute is allowed on any of nodes in that range,
     * * if the selection is collapsed, then checks if on the selection position there's a text with the
     * specified attribute allowed.
     *
     * @param {module:engine/model/selection~Selection|module:engine/model/documentselection~DocumentSelection} selection
     * Selection which will be checked.
     * @param {String} attribute The name of the attribute to check.
     * @returns {Boolean}
     */

  }, {
    key: "checkAttributeInSelection",
    value: function checkAttributeInSelection(selection, attribute) {
      if (selection.isCollapsed) {
        var firstPosition = selection.getFirstPosition();
        var context = [].concat(_toConsumableArray(firstPosition.getAncestors()), [new Text('', selection.getAttributes())]); // Check whether schema allows for a text with the attribute in the selection.

        return this.checkAttribute(context, attribute);
      } else {
        var ranges = selection.getRanges(); // For all ranges, check nodes in them until you find a node that is allowed to have the attribute.

        var _iterator2 = _createForOfIteratorHelper(ranges),
            _step2;

        try {
          for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
            var range = _step2.value;

            var _iterator3 = _createForOfIteratorHelper(range),
                _step3;

            try {
              for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
                var value = _step3.value;

                if (this.checkAttribute(value.item, attribute)) {
                  // If we found a node that is allowed to have the attribute, return true.
                  return true;
                }
              }
            } catch (err) {
              _iterator3.e(err);
            } finally {
              _iterator3.f();
            }
          }
        } catch (err) {
          _iterator2.e(err);
        } finally {
          _iterator2.f();
        }
      } // If we haven't found such node, return false.


      return false;
    }
    /**
     * Transforms the given set of ranges into a set of ranges where the given attribute is allowed (and can be applied).
     *
     * @param {Array.<module:engine/model/range~Range>} ranges Ranges to be validated.
     * @param {String} attribute The name of the attribute to check.
     * @returns {Iterable.<module:engine/model/range~Range>} Ranges in which the attribute is allowed.
     */

  }, {
    key: "getValidRanges",
    value:
    /*#__PURE__*/
    _regeneratorRuntime.mark(function getValidRanges(ranges, attribute) {
      var _iterator4, _step4, range;

      return _regeneratorRuntime.wrap(function getValidRanges$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              ranges = convertToMinimalFlatRanges(ranges);
              _iterator4 = _createForOfIteratorHelper(ranges);
              _context.prev = 2;

              _iterator4.s();

            case 4:
              if ((_step4 = _iterator4.n()).done) {
                _context.next = 9;
                break;
              }

              range = _step4.value;
              return _context.delegateYield(this._getValidRangesForRange(range, attribute), "t0", 7);

            case 7:
              _context.next = 4;
              break;

            case 9:
              _context.next = 14;
              break;

            case 11:
              _context.prev = 11;
              _context.t1 = _context["catch"](2);

              _iterator4.e(_context.t1);

            case 14:
              _context.prev = 14;

              _iterator4.f();

              return _context.finish(14);

            case 17:
            case "end":
              return _context.stop();
          }
        }
      }, getValidRanges, this, [[2, 11, 14, 17]]);
    })
    /**
     * Basing on given `position`, finds and returns a {@link module:engine/model/range~Range range} which is
     * nearest to that `position` and is a correct range for selection.
     *
     * The correct selection range might be collapsed when it is located in a position where the text node can be placed.
     * Non-collapsed range is returned when selection can be placed around element marked as an "object" in
     * the {@link module:engine/model/schema~Schema schema}.
     *
     * Direction of searching for the nearest correct selection range can be specified as:
     *
     * * `both` - searching will be performed in both ways,
     * * `forward` - searching will be performed only forward,
     * * `backward` - searching will be performed only backward.
     *
     * When valid selection range cannot be found, `null` is returned.
     *
     * @param {module:engine/model/position~Position} position Reference position where new selection range should be looked for.
     * @param {'both'|'forward'|'backward'} [direction='both'] Search direction.
     * @returns {module:engine/model/range~Range|null} Nearest selection range or `null` if one cannot be found.
     */

  }, {
    key: "getNearestSelectionRange",
    value: function getNearestSelectionRange(position) {
      var _this2 = this;

      var direction = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'both';

      // Return collapsed range if provided position is valid.
      if (this.checkChild(position, '$text')) {
        return new Range(position);
      }

      var backwardWalker, forwardWalker; // Never leave a limit element.

      var limitElement = position.getAncestors().reverse().find(function (item) {
        return _this2.isLimit(item);
      }) || position.root;

      if (direction == 'both' || direction == 'backward') {
        backwardWalker = new TreeWalker({
          boundaries: Range._createIn(limitElement),
          startPosition: position,
          direction: 'backward'
        });
      }

      if (direction == 'both' || direction == 'forward') {
        forwardWalker = new TreeWalker({
          boundaries: Range._createIn(limitElement),
          startPosition: position
        });
      }

      var _iterator5 = _createForOfIteratorHelper(combineWalkers(backwardWalker, forwardWalker)),
          _step5;

      try {
        for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
          var data = _step5.value;
          var type = data.walker == backwardWalker ? 'elementEnd' : 'elementStart';
          var value = data.value;

          if (value.type == type && this.isObject(value.item)) {
            return Range._createOn(value.item);
          }

          if (this.checkChild(value.nextPosition, '$text')) {
            return new Range(value.nextPosition);
          }
        }
      } catch (err) {
        _iterator5.e(err);
      } finally {
        _iterator5.f();
      }

      return null;
    }
    /**
     * Tries to find position ancestors that allow to insert a given node.
     * It starts searching from the given position and goes node by node to the top of the model tree
     * as long as a {@link module:engine/model/schema~Schema#isLimit limit element}, an
     * {@link module:engine/model/schema~Schema#isObject object element} or a topmost ancestor is not reached.
     *
     * @param {module:engine/model/position~Position} position The position that the search will start from.
     * @param {module:engine/model/node~Node|String} node The node for which an allowed parent should be found or its name.
     * @returns {module:engine/model/element~Element|null} element Allowed parent or null if nothing was found.
     */

  }, {
    key: "findAllowedParent",
    value: function findAllowedParent(position, node) {
      var parent = position.parent;

      while (parent) {
        if (this.checkChild(parent, node)) {
          return parent;
        } // Do not split limit elements.


        if (this.isLimit(parent)) {
          return null;
        }

        parent = parent.parent;
      }

      return null;
    }
    /**
     * Removes attributes disallowed by the schema.
     *
     * @param {Iterable.<module:engine/model/node~Node>} nodes Nodes that will be filtered.
     * @param {module:engine/model/writer~Writer} writer
     */

  }, {
    key: "removeDisallowedAttributes",
    value: function removeDisallowedAttributes(nodes, writer) {
      var _iterator6 = _createForOfIteratorHelper(nodes),
          _step6;

      try {
        for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
          var node = _step6.value;

          // When node is a `Text` it has no children, so just filter it out.
          if (node.is('$text')) {
            removeDisallowedAttributeFromNode(this, node, writer);
          } // In a case of `Element` iterates through positions between nodes inside this element
          // and filter out node before the current position, or position parent when position
          // is at start of an element. Using positions prevent from omitting merged nodes
          // see https://github.com/ckeditor/ckeditor5-engine/issues/1789.
          else {
              var rangeInNode = Range._createIn(node);

              var positionsInRange = rangeInNode.getPositions();

              var _iterator7 = _createForOfIteratorHelper(positionsInRange),
                  _step7;

              try {
                for (_iterator7.s(); !(_step7 = _iterator7.n()).done;) {
                  var position = _step7.value;
                  var item = position.nodeBefore || position.parent;
                  removeDisallowedAttributeFromNode(this, item, writer);
                }
              } catch (err) {
                _iterator7.e(err);
              } finally {
                _iterator7.f();
              }
            }
        }
      } catch (err) {
        _iterator6.e(err);
      } finally {
        _iterator6.f();
      }
    }
    /**
     * Creates an instance of the schema context.
     *
     * @param {module:engine/model/schema~SchemaContextDefinition} context
     * @returns {module:engine/model/schema~SchemaContext}
     */

  }, {
    key: "createContext",
    value: function createContext(context) {
      return new SchemaContext(context);
    }
    /**
     * @private
     */

  }, {
    key: "_clearCache",
    value: function _clearCache() {
      this._compiledDefinitions = null;
    }
    /**
     * @private
     */

  }, {
    key: "_compile",
    value: function _compile() {
      var compiledDefinitions = {};
      var sourceRules = this._sourceDefinitions;
      var itemNames = Object.keys(sourceRules);

      for (var _i2 = 0, _itemNames = itemNames; _i2 < _itemNames.length; _i2++) {
        var itemName = _itemNames[_i2];
        compiledDefinitions[itemName] = compileBaseItemRule(sourceRules[itemName], itemName);
      }

      for (var _i3 = 0, _itemNames2 = itemNames; _i3 < _itemNames2.length; _i3++) {
        var _itemName = _itemNames2[_i3];
        compileAllowChildren(compiledDefinitions, _itemName);
      }

      for (var _i4 = 0, _itemNames3 = itemNames; _i4 < _itemNames3.length; _i4++) {
        var _itemName2 = _itemNames3[_i4];
        compileAllowContentOf(compiledDefinitions, _itemName2);
      }

      for (var _i5 = 0, _itemNames4 = itemNames; _i5 < _itemNames4.length; _i5++) {
        var _itemName3 = _itemNames4[_i5];
        compileAllowWhere(compiledDefinitions, _itemName3);
      }

      for (var _i6 = 0, _itemNames5 = itemNames; _i6 < _itemNames5.length; _i6++) {
        var _itemName4 = _itemNames5[_i6];
        compileAllowAttributesOf(compiledDefinitions, _itemName4);
        compileInheritPropertiesFrom(compiledDefinitions, _itemName4);
      }

      for (var _i7 = 0, _itemNames6 = itemNames; _i7 < _itemNames6.length; _i7++) {
        var _itemName5 = _itemNames6[_i7];
        cleanUpAllowIn(compiledDefinitions, _itemName5);
        setupAllowChildren(compiledDefinitions, _itemName5);
        cleanUpAllowAttributes(compiledDefinitions, _itemName5);
      }

      this._compiledDefinitions = compiledDefinitions;
    }
    /**
     * @private
     * @param {module:engine/model/schema~SchemaCompiledItemDefinition} def
     * @param {module:engine/model/schema~SchemaContext} context
     * @param {Number} contextItemIndex
     */

  }, {
    key: "_checkContextMatch",
    value: function _checkContextMatch(def, context) {
      var contextItemIndex = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : context.length - 1;
      var contextItem = context.getItem(contextItemIndex);

      if (def.allowIn.includes(contextItem.name)) {
        if (contextItemIndex == 0) {
          return true;
        } else {
          var parentRule = this.getDefinition(contextItem);
          return this._checkContextMatch(parentRule, context, contextItemIndex - 1);
        }
      } else {
        return false;
      }
    }
    /**
     * Takes a flat range and an attribute name. Traverses the range recursively and deeply to find and return all ranges
     * inside the given range on which the attribute can be applied.
     *
     * This is a helper function for {@link ~Schema#getValidRanges}.
     *
     * @private
     * @param {module:engine/model/range~Range} range The range to process.
     * @param {String} attribute The name of the attribute to check.
     * @returns {Iterable.<module:engine/model/range~Range>} Ranges in which the attribute is allowed.
     */

  }, {
    key: "_getValidRangesForRange",
    value:
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _getValidRangesForRange(range, attribute) {
      var start, end, _iterator8, _step8, item;

      return _regeneratorRuntime.wrap(function _getValidRangesForRange$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              start = range.start;
              end = range.start;
              _iterator8 = _createForOfIteratorHelper(range.getItems({
                shallow: true
              }));
              _context2.prev = 3;

              _iterator8.s();

            case 5:
              if ((_step8 = _iterator8.n()).done) {
                _context2.next = 17;
                break;
              }

              item = _step8.value;

              if (!item.is('element')) {
                _context2.next = 9;
                break;
              }

              return _context2.delegateYield(this._getValidRangesForRange(Range._createIn(item), attribute), "t0", 9);

            case 9:
              if (this.checkAttribute(item, attribute)) {
                _context2.next = 14;
                break;
              }

              if (start.isEqual(end)) {
                _context2.next = 13;
                break;
              }

              _context2.next = 13;
              return new Range(start, end);

            case 13:
              start = Position._createAfter(item);

            case 14:
              end = Position._createAfter(item);

            case 15:
              _context2.next = 5;
              break;

            case 17:
              _context2.next = 22;
              break;

            case 19:
              _context2.prev = 19;
              _context2.t1 = _context2["catch"](3);

              _iterator8.e(_context2.t1);

            case 22:
              _context2.prev = 22;

              _iterator8.f();

              return _context2.finish(22);

            case 25:
              if (start.isEqual(end)) {
                _context2.next = 28;
                break;
              }

              _context2.next = 28;
              return new Range(start, end);

            case 28:
            case "end":
              return _context2.stop();
          }
        }
      }, _getValidRangesForRange, this, [[3, 19, 22, 25]]);
    })
  }]);

  return Schema;
}();

export { Schema as default };
mix(Schema, ObservableMixin);
/**
 * Event fired when the {@link #checkChild} method is called. It allows plugging in
 * additional behavior, for example implementing rules which cannot be defined using the declarative
 * {@link module:engine/model/schema~SchemaItemDefinition} interface.
 *
 * **Note:** The {@link #addChildCheck} method is a more handy way to register callbacks. Internally,
 * it registers a listener to this event but comes with a simpler API and it is the recommended choice
 * in most of the cases.
 *
 * The {@link #checkChild} method fires an event because it is
 * {@link module:utils/observablemixin~ObservableMixin#decorate decorated} with it. Thanks to that you can
 * use this event in various ways, but the most important use case is overriding standard behavior of the
 * `checkChild()` method. Let's see a typical listener template:
 *
 *		schema.on( 'checkChild', ( evt, args ) => {
 *			const context = args[ 0 ];
 *			const childDefinition = args[ 1 ];
 *		}, { priority: 'high' } );
 *
 * The listener is added with a `high` priority to be executed before the default method is really called. The `args` callback
 * parameter contains arguments passed to `checkChild( context, child )`. However, the `context` parameter is already
 * normalized to a {@link module:engine/model/schema~SchemaContext} instance and `child` to a
 * {@link module:engine/model/schema~SchemaCompiledItemDefinition} instance, so you do not have to worry about
 * the various ways how `context` and `child` may be passed to `checkChild()`.
 *
 * **Note:** `childDefinition` may be `undefined` if `checkChild()` was called with a non-registered element.
 *
 * So, in order to implement a rule "disallow `heading1` in `blockQuote`", you can add such a listener:
 *
 *		schema.on( 'checkChild', ( evt, args ) => {
 *			const context = args[ 0 ];
 *			const childDefinition = args[ 1 ];
 *
 *			if ( context.endsWith( 'blockQuote' ) && childDefinition && childDefinition.name == 'heading1' ) {
 *				// Prevent next listeners from being called.
 *				evt.stop();
 *				// Set the checkChild()'s return value.
 *				evt.return = false;
 *			}
 *		}, { priority: 'high' } );
 *
 * Allowing elements in specific contexts will be a far less common use case, because it is normally handled by the
 * `allowIn` rule from {@link module:engine/model/schema~SchemaItemDefinition}. But if you have a complex scenario
 * where `listItem` should be allowed only in element `foo` which must be in element `bar`, then this would be the way:
 *
 *		schema.on( 'checkChild', ( evt, args ) => {
 *			const context = args[ 0 ];
 *			const childDefinition = args[ 1 ];
 *
 *			if ( context.endsWith( 'bar foo' ) && childDefinition.name == 'listItem' ) {
 *				// Prevent next listeners from being called.
 *				evt.stop();
 *				// Set the checkChild()'s return value.
 *				evt.return = true;
 *			}
 *		}, { priority: 'high' } );
 *
 * @event checkChild
 * @param {Array} args The `checkChild()`'s arguments.
 */

/**
 * Event fired when the {@link #checkAttribute} method is called. It allows plugging in
 * additional behavior, for example implementing rules which cannot be defined using the declarative
 * {@link module:engine/model/schema~SchemaItemDefinition} interface.
 *
 * **Note:** The {@link #addAttributeCheck} method is a more handy way to register callbacks. Internally,
 * it registers a listener to this event but comes with a simpler API and it is the recommended choice
 * in most of the cases.
 *
 * The {@link #checkAttribute} method fires an event because it is
 * {@link module:utils/observablemixin~ObservableMixin#decorate decorated} with it. Thanks to that you can
 * use this event in various ways, but the most important use case is overriding the standard behavior of the
 * `checkAttribute()` method. Let's see a typical listener template:
 *
 *		schema.on( 'checkAttribute', ( evt, args ) => {
 *			const context = args[ 0 ];
 *			const attributeName = args[ 1 ];
 *		}, { priority: 'high' } );
 *
 * The listener is added with a `high` priority to be executed before the default method is really called. The `args` callback
 * parameter contains arguments passed to `checkAttribute( context, attributeName )`. However, the `context` parameter is already
 * normalized to a {@link module:engine/model/schema~SchemaContext} instance, so you do not have to worry about
 * the various ways how `context` may be passed to `checkAttribute()`.
 *
 * So, in order to implement a rule "disallow `bold` in a text which is in a `heading1`, you can add such a listener:
 *
 *		schema.on( 'checkAttribute', ( evt, args ) => {
 *			const context = args[ 0 ];
 *			const attributeName = args[ 1 ];
 *
 *			if ( context.endsWith( 'heading1 $text' ) && attributeName == 'bold' ) {
 *				// Prevent next listeners from being called.
 *				evt.stop();
 *				// Set the checkAttribute()'s return value.
 *				evt.return = false;
 *			}
 *		}, { priority: 'high' } );
 *
 * Allowing attributes in specific contexts will be a far less common use case, because it is normally handled by the
 * `allowAttributes` rule from {@link module:engine/model/schema~SchemaItemDefinition}. But if you have a complex scenario
 * where `bold` should be allowed only in element `foo` which must be in element `bar`, then this would be the way:
 *
 *		schema.on( 'checkAttribute', ( evt, args ) => {
 *			const context = args[ 0 ];
 *			const attributeName = args[ 1 ];
 *
 *			if ( context.endsWith( 'bar foo $text' ) && attributeName == 'bold' ) {
 *				// Prevent next listeners from being called.
 *				evt.stop();
 *				// Set the checkAttribute()'s return value.
 *				evt.return = true;
 *			}
 *		}, { priority: 'high' } );
 *
 * @event checkAttribute
 * @param {Array} args The `checkAttribute()`'s arguments.
 */

/**
 * A definition of a {@link module:engine/model/schema~Schema schema} item.
 *
 * You can define the following rules:
 *
 * * {@link ~SchemaItemDefinition#allowIn `allowIn`} &ndash; Defines in which other items this item will be allowed.
 * * {@link ~SchemaItemDefinition#allowChildren `allowChildren`} &ndash; Defines which other items are allowed inside this item.
 * * {@link ~SchemaItemDefinition#allowAttributes `allowAttributes`} &ndash; Defines allowed attributes of the given item.
 * * {@link ~SchemaItemDefinition#allowContentOf `allowContentOf`} &ndash; Inherits "allowed children" from other items.
 * * {@link ~SchemaItemDefinition#allowWhere `allowWhere`} &ndash; Inherits "allowed in" from other items.
 * * {@link ~SchemaItemDefinition#allowAttributesOf `allowAttributesOf`} &ndash; Inherits attributes from other items.
 * * {@link ~SchemaItemDefinition#inheritTypesFrom `inheritTypesFrom`} &ndash; Inherits `is*` properties of other items.
 * * {@link ~SchemaItemDefinition#inheritAllFrom `inheritAllFrom`} &ndash;
 * A shorthand for `allowContentOf`, `allowWhere`, `allowAttributesOf`, `inheritTypesFrom`.
 *
 * # The `is*` properties
 *
 * There are a couple commonly used `is*` properties. Their role is to assign additional semantics to schema items.
 * You can define more properties but you will also need to implement support for them in the existing editor features.
 *
 * * {@link ~SchemaItemDefinition#isBlock `isBlock`} &ndash; Whether this item is paragraph-like.
 * Generally speaking, content is usually made out of blocks like paragraphs, list items, images, headings, etc.
 * * {@link ~SchemaItemDefinition#isInline `isInline`} &ndash; Whether an item is "text-like" and should be treated as an inline node.
 * Examples of inline elements: `$text`, `softBreak` (`<br>`), etc.
 * * {@link ~SchemaItemDefinition#isLimit `isLimit`} &ndash; It can be understood as whether this element
 * should not be split by <kbd>Enter</kbd>. Examples of limit elements: `$root`, table cell, image caption, etc.
 * In other words, all actions that happen inside a limit element are limited to its content.
 * All objects are treated as limit elements, too.
 * * {@link ~SchemaItemDefinition#isObject `isObject`} &ndash; Whether an item is "self-contained" and should be treated as a whole.
 * Examples of object elements: `imageBlock`, `table`, `video`, etc. An object is also a limit, so
 * {@link module:engine/model/schema~Schema#isLimit `isLimit()`} returns `true` for object elements automatically.
 *
 * Read more about the meaning of these types in the
 * {@glink framework/guides/deep-dive/schema#defining-additional-semantics dedicated section of the Schema deep dive} guide.
 *
 * # Generic items
 *
 * There are three basic generic items: `$root`, `$block` and `$text`.
 * They are defined as follows:
 *
 *		this.schema.register( '$root', {
 *			isLimit: true
 *		} );
 *		this.schema.register( '$block', {
 *			allowIn: '$root',
 *			isBlock: true
 *		} );
 *		this.schema.register( '$text', {
 *			allowIn: '$block',
 *			isInline: true
 *		} );
 *
 * They reflect typical editor content that is contained within one root, consists of several blocks
 * (paragraphs, lists items, headings, images) which, in turn, may contain text inside.
 *
 * By inheriting from the generic items you can define new items which will get extended by other editor features.
 * Read more about generic types in the {@glink framework/guides/deep-dive/schema Schema deep dive} guide.
 *
 * # Example definitions
 *
 * Allow `paragraph` in roots and block quotes:
 *
 *		schema.register( 'paragraph', {
 *			allowIn: [ '$root', 'blockQuote' ],
 *			isBlock: true
 *		} );
 *
 * Allow `paragraph` everywhere where `$block` is allowed (i.e. in `$root`):
 *
 *		schema.register( 'paragraph', {
 *			allowWhere: '$block',
 *			isBlock: true
 *		} );
 *
 * Allow `paragraph` inside a `$root` and allow `$text` as a `paragraph` child:
 *
 *		schema.register( 'paragraph', {
 *			allowIn: '$root',
 *			allowChildren: '$text',
 *			isBlock: true
 *		} );
 *
 * Make `imageBlock` a block object, which is allowed everywhere where `$block` is.
 * Also, allow `src` and `alt` attributes in it:
 *
 *		schema.register( 'imageBlock', {
 *			allowWhere: '$block',
 *			allowAttributes: [ 'src', 'alt' ],
 *			isBlock: true,
 *			isObject: true
 *		} );
 *
 * Make `caption` allowed in `imageBlock` and make it allow all the content of `$block`s (usually, `$text`).
 * Also, mark it as a limit element so it cannot be split:
 *
 *		schema.register( 'caption', {
 *			allowIn: 'imageBlock',
 *			allowContentOf: '$block',
 *			isLimit: true
 *		} );
 *
 * Make `listItem` inherit all from `$block` but also allow additional attributes:
 *
 *		schema.register( 'listItem', {
 *			inheritAllFrom: '$block',
 *			allowAttributes: [ 'listType', 'listIndent' ]
 *		} );
 *
 * Which translates to:
 *
 *		schema.register( 'listItem', {
 *			allowWhere: '$block',
 *			allowContentOf: '$block',
 *			allowAttributesOf: '$block',
 *			inheritTypesFrom: '$block',
 *			allowAttributes: [ 'listType', 'listIndent' ]
 *		} );
 *
 * # Tips
 *
 * * Check schema definitions of existing features to see how they are defined.
 * * If you want to publish your feature so other developers can use it, try to use
 * generic items as much as possible.
 * * Keep your model clean. Limit it to the actual data and store information in a normalized way.
 * * Remember about defining the `is*` properties. They do not affect the allowed structures, but they can
 * affect how the editor features treat your elements.
 *
 * @typedef {Object} module:engine/model/schema~SchemaItemDefinition
 *
 * @property {String|Array.<String>} allowIn Defines in which other items this item will be allowed.
 * @property {String|Array.<String>} allowChildren Defines which other items are allowed inside this item.
 * @property {String|Array.<String>} allowAttributes Defines allowed attributes of the given item.
 * @property {String|Array.<String>} allowContentOf Inherits "allowed children" from other items.
 * @property {String|Array.<String>} allowWhere Inherits "allowed in" from other items.
 * @property {String|Array.<String>} allowAttributesOf Inherits attributes from other items.
 * @property {String|Array.<String>} inheritTypesFrom Inherits `is*` properties of other items.
 * @property {String} inheritAllFrom A shorthand for `allowContentOf`, `allowWhere`, `allowAttributesOf`, `inheritTypesFrom`.
 *
 * @property {Boolean} isBlock
 * Whether this item is paragraph-like. Generally speaking, content is usually made out of blocks
 * like paragraphs, list items, images, headings, etc. All these elements are marked as blocks. A block
 * should not allow another block inside. Note: There is also the `$block` generic item which has `isBlock` set to `true`.
 * Most block type items will inherit from `$block` (through `inheritAllFrom`).
 *
 * Read more about the block elements in the
 * {@glink framework/guides/deep-dive/schema#block-elements Block elements section} of the Schema deep dive guide.
 *
 * @property {Boolean} isInline
 * Whether an item is "text-like" and should be treated as an inline node. Examples of inline elements:
 * `$text`, `softBreak` (`<br>`), etc.
 *
 * Read more about the inline elements in the
 * {@glink framework/guides/deep-dive/schema#inline-elements Inline elements section} of the Schema deep dive guide.
 *
 * @property {Boolean} isLimit
 * It can be understood as whether this element should not be split by <kbd>Enter</kbd>.
 * Examples of limit elements: `$root`, table cell, image caption, etc. In other words, all actions that happen inside
 * a limit element are limited to its content.
 *
 * Read more about the limit elements in the
 * {@glink framework/guides/deep-dive/schema#limit-elements Limit elements section} of the Schema deep dive guide.
 *
 * @property {Boolean} isObject
 * Whether an item is "self-contained" and should be treated as a whole. Examples of object elements:
 * `imageBlock`, `table`, `video`, etc.
 *
 * **Note:** An object is also a limit, so
 * {@link module:engine/model/schema~Schema#isLimit `isLimit()`} returns `true` for object elements automatically.
 *
 * Read more about the object elements in the
 * {@glink framework/guides/deep-dive/schema#object-elements Object elements section} of the Schema deep dive guide.
 *
 * @property {Boolean} isSelectable
 * `true` when an element should be selectable as a whole by the user. Examples of selectable elements: `imageBlock`, `table`, `tableCell`,
 * etc.
 *
 * **Note:** An object is also a selectable element, so
 * {@link module:engine/model/schema~Schema#isSelectable `isSelectable()`} returns `true` for object elements automatically.
 *
 * Read more about selectable elements in the
 * {@glink framework/guides/deep-dive/schema#selectable-elements Selectable elements section} of the Schema deep dive guide.
 *
 * @property {Boolean} isContent
 * An item is a content when it always finds its way to the editor data output regardless of the number and type of its descendants.
 * Examples of content elements: `$text`, `imageBlock`, `table`, etc. (but not `paragraph`, `heading1` or `tableCell`).
 *
 * **Note:** An object is also a content element, so
 * {@link module:engine/model/schema~Schema#isContent `isContent()`} returns `true` for object elements automatically.
 *
 * Read more about content elements in the
 * {@glink framework/guides/deep-dive/schema#content-elements Content elements section} of the Schema deep dive guide.
 */

/**
 * A simplified version of {@link module:engine/model/schema~SchemaItemDefinition} after
 * compilation by the {@link module:engine/model/schema~Schema schema}.
 * Rules fed to the schema by {@link module:engine/model/schema~Schema#register}
 * and {@link module:engine/model/schema~Schema#extend} methods are defined in the
 * {@link module:engine/model/schema~SchemaItemDefinition} format.
 * Later on, they are compiled to `SchemaCompiledItemDefinition` so when you use e.g.
 * the {@link module:engine/model/schema~Schema#getDefinition} method you get the compiled version.
 *
 * The compiled version contains only the following properties:
 *
 * * The `name` property,
 * * The `is*` properties,
 * * The `allowIn` array,
 * * The `allowChildren` array,
 * * The `allowAttributes` array.
 *
 * @typedef {Object} module:engine/model/schema~SchemaCompiledItemDefinition
 */

/**
 * A schema context &mdash; a list of ancestors of a given position in the document.
 *
 * Considering such position:
 *
 *		<$root>
 *			<blockQuote>
 *				<paragraph>
 *					^
 *				</paragraph>
 *			</blockQuote>
 *		</$root>
 *
 * The context of this position is its {@link module:engine/model/position~Position#getAncestors lists of ancestors}:
 *
 *		[ rootElement, blockQuoteElement, paragraphElement ]
 *
 * Contexts are used in the {@link module:engine/model/schema~Schema#event:checkChild `Schema#checkChild`} and
 * {@link module:engine/model/schema~Schema#event:checkAttribute `Schema#checkAttribute`} events as a definition
 * of a place in the document where the check occurs. The context instances are created based on the first arguments
 * of the {@link module:engine/model/schema~Schema#checkChild `Schema#checkChild()`} and
 * {@link module:engine/model/schema~Schema#checkAttribute `Schema#checkAttribute()`} methods so when
 * using these methods you need to use {@link module:engine/model/schema~SchemaContextDefinition}s.
 */

export var SchemaContext = /*#__PURE__*/function () {
  /**
   * Creates an instance of the context.
   *
   * @param {module:engine/model/schema~SchemaContextDefinition} context
   */
  function SchemaContext(context) {
    _classCallCheck(this, SchemaContext);

    if (context instanceof SchemaContext) {
      return context;
    }

    if (typeof context == 'string') {
      context = [context];
    } else if (!Array.isArray(context)) {
      // `context` is item or position.
      // Position#getAncestors() doesn't accept any parameters but it works just fine here.
      context = context.getAncestors({
        includeSelf: true
      });
    }

    this._items = context.map(mapContextItem);
  }
  /**
   * The number of items.
   *
   * @type {Number}
   */


  _createClass(SchemaContext, [{
    key: "length",
    get: function get() {
      return this._items.length;
    }
    /**
     * The last item (the lowest node).
     *
     * @type {module:engine/model/schema~SchemaContextItem}
     */

  }, {
    key: "last",
    get: function get() {
      return this._items[this._items.length - 1];
    }
    /**
     * Iterable interface.
     *
     * Iterates over all context items.
     *
     * @returns {Iterable.<module:engine/model/schema~SchemaContextItem>}
     */

  }, {
    key: Symbol.iterator,
    value: function value() {
      return this._items[Symbol.iterator]();
    }
    /**
     * Returns a new schema context instance with an additional item.
     *
     * Item can be added as:
     *
     * 		const context = new SchemaContext( [ '$root' ] );
     *
     * 		// An element.
     * 		const fooElement = writer.createElement( 'fooElement' );
     * 		const newContext = context.push( fooElement ); // [ '$root', 'fooElement' ]
     *
     * 		// A text node.
     * 		const text = writer.createText( 'foobar' );
     * 		const newContext = context.push( text ); // [ '$root', '$text' ]
     *
     * 		// A string (element name).
     * 		const newContext = context.push( 'barElement' ); // [ '$root', 'barElement' ]
     *
     * **Note** {@link module:engine/model/node~Node} that is already in the model tree will be added as the only item
     * (without ancestors).
     *
     * @param {String|module:engine/model/node~Node|Array<String|module:engine/model/node~Node>} item An item that will be added
     * to the current context.
     * @returns {module:engine/model/schema~SchemaContext} A new schema context instance with an additional item.
     */

  }, {
    key: "push",
    value: function push(item) {
      var ctx = new SchemaContext([item]);
      ctx._items = [].concat(_toConsumableArray(this._items), _toConsumableArray(ctx._items));
      return ctx;
    }
    /**
     * Gets an item on the given index.
     *
     * @returns {module:engine/model/schema~SchemaContextItem}
     */

  }, {
    key: "getItem",
    value: function getItem(index) {
      return this._items[index];
    }
    /**
     * Returns the names of items.
     *
     * @returns {Iterable.<String>}
     */

  }, {
    key: "getNames",
    value:
    /*#__PURE__*/
    _regeneratorRuntime.mark(function getNames() {
      return _regeneratorRuntime.wrap(function getNames$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              return _context3.delegateYield(this._items.map(function (item) {
                return item.name;
              }), "t0", 1);

            case 1:
            case "end":
              return _context3.stop();
          }
        }
      }, getNames, this);
    })
    /**
     * Checks whether the context ends with the given nodes.
     *
     *		const ctx = new SchemaContext( [ rootElement, paragraphElement, textNode ] );
     *
     *		ctx.endsWith( '$text' ); // -> true
     *		ctx.endsWith( 'paragraph $text' ); // -> true
     *		ctx.endsWith( '$root' ); // -> false
     *		ctx.endsWith( 'paragraph' ); // -> false
     *
     * @param {String} query
     * @returns {Boolean}
     */

  }, {
    key: "endsWith",
    value: function endsWith(query) {
      return Array.from(this.getNames()).join(' ').endsWith(query);
    }
    /**
     * Checks whether the context starts with the given nodes.
     *
     *		const ctx = new SchemaContext( [ rootElement, paragraphElement, textNode ] );
     *
     *		ctx.endsWith( '$root' ); // -> true
     *		ctx.endsWith( '$root paragraph' ); // -> true
     *		ctx.endsWith( '$text' ); // -> false
     *		ctx.endsWith( 'paragraph' ); // -> false
     *
     * @param {String} query
     * @returns {Boolean}
     */

  }, {
    key: "startsWith",
    value: function startsWith(query) {
      return Array.from(this.getNames()).join(' ').startsWith(query);
    }
  }]);

  return SchemaContext;
}();
/**
 * The definition of a {@link module:engine/model/schema~SchemaContext schema context}.
 *
 * Contexts can be created in multiple ways:
 *
 * * By defining a **node** – in this cases this node and all its ancestors will be used.
 * * By defining a **position** in the document – in this case all its ancestors will be used.
 * * By defining an **array of nodes** – in this case this array defines the entire context.
 * * By defining a **name of node** - in this case node will be "mocked". It is not recommended because context
 * will be unrealistic (e.g. attributes of these nodes are not specified). However, at times this may be the only
 * way to define the context (e.g. when checking some hypothetical situation).
 * * By defining an **array of node names** (potentially, mixed with real nodes) – The same as **name of node**
 * but it is possible to create a path.
 * * By defining a {@link module:engine/model/schema~SchemaContext} instance - in this case the same instance as provided
 * will be return.
 *
 * Examples of context definitions passed to the {@link module:engine/model/schema~Schema#checkChild `Schema#checkChild()`}
 * method:
 *
 *		// Assuming that we have a $root > blockQuote > paragraph structure, the following code
 *		// will check node 'foo' in the following context:
 *		// [ rootElement, blockQuoteElement, paragraphElement ]
 *		const contextDefinition = paragraphElement;
 * 		const childToCheck = 'foo';
 *		schema.checkChild( contextDefinition, childToCheck );
 *
 *		// Also check in [ rootElement, blockQuoteElement, paragraphElement ].
 *		schema.checkChild( model.createPositionAt( paragraphElement, 0 ), 'foo' );
 *
 *		// Check in [ rootElement, paragraphElement ].
 *		schema.checkChild( [ rootElement, paragraphElement ], 'foo' );
 *
 *		// Check only fakeParagraphElement.
 *		schema.checkChild( 'paragraph', 'foo' );
 *
 *		// Check in [ fakeRootElement, fakeBarElement, paragraphElement ].
 *		schema.checkChild( [ '$root', 'bar', paragraphElement ], 'foo' );
 *
 * All these `checkChild()` calls will fire {@link module:engine/model/schema~Schema#event:checkChild `Schema#checkChild`}
 * events in which `args[ 0 ]` is an instance of the context. Therefore, you can write a listener like this:
 *
 *		schema.on( 'checkChild', ( evt, args ) => {
 *			const ctx = args[ 0 ];
 *
 *			console.log( Array.from( ctx.getNames() ) );
 *		} );
 *
 * Which will log the following:
 *
 *		[ '$root', 'blockQuote', 'paragraph' ]
 *		[ '$root', 'paragraph' ]
 *		[ '$root', 'bar', 'paragraph' ]
 *
 * Note: When using the {@link module:engine/model/schema~Schema#checkAttribute `Schema#checkAttribute()`} method
 * you may want to check whether a text node may have an attribute. A {@link module:engine/model/text~Text} is a
 * correct way to define a context so you can do this:
 *
 *		schema.checkAttribute( textNode, 'bold' );
 *
 * But sometimes you want to check whether a text at a given position might've had some attribute,
 * in which case you can create a context by mixing in an array of elements with a `'$text'` string:
 *
 *		// Check in [ rootElement, paragraphElement, textNode ].
 *		schema.checkChild( [ ...positionInParagraph.getAncestors(), '$text' ], 'bold' );
 *
 * @typedef {module:engine/model/node~Node|module:engine/model/position~Position|module:engine/model/schema~SchemaContext|
 * String|Array.<String|module:engine/model/node~Node>} module:engine/model/schema~SchemaContextDefinition
 */

/**
 * An item of the {@link module:engine/model/schema~SchemaContext schema context}.
 *
 * It contains 3 properties:
 *
 * * `name` – the name of this item,
 * * `* getAttributeKeys()` – a generator of keys of item attributes,
 * * `getAttribute( keyName )` – a method to get attribute values.
 *
 * The context item interface is a highly simplified version of {@link module:engine/model/node~Node} and its role
 * is to expose only the information which schema checks are able to provide (which is the name of the node and
 * node's attributes).
 *
 *		schema.on( 'checkChild', ( evt, args ) => {
 *			const ctx = args[ 0 ];
 *			const firstItem = ctx.getItem( 0 );
 *
 *			console.log( firstItem.name ); // -> '$root'
 *			console.log( firstItem.getAttribute( 'foo' ) ); // -> 'bar'
 *			console.log( Array.from( firstItem.getAttributeKeys() ) ); // -> [ 'foo', 'faa' ]
 *		} );
 *
 * @typedef {Object} module:engine/model/schema~SchemaContextItem
 */

/**
 * A structure containing additional metadata describing the attribute.
 *
 * See {@link module:engine/model/schema~Schema#setAttributeProperties `Schema#setAttributeProperties()`} for usage examples.
 *
 * @typedef {Object} module:engine/model/schema~AttributeProperties
 * @property {Boolean} [isFormatting] Indicates that the attribute should be considered as a visual formatting, like `bold`, `italic` or
 * `fontSize` rather than semantic attribute (such as `src`, `listType`, etc.). For example, it is used by the "Remove format" feature.
 * @property {Boolean} [copyOnEnter] Indicates that given text attribute should be copied to the next block when enter is pressed.
 */

function compileBaseItemRule(sourceItemRules, itemName) {
  var itemRule = {
    name: itemName,
    allowIn: [],
    allowContentOf: [],
    allowWhere: [],
    allowAttributes: [],
    allowAttributesOf: [],
    allowChildren: [],
    inheritTypesFrom: []
  };
  copyTypes(sourceItemRules, itemRule);
  copyProperty(sourceItemRules, itemRule, 'allowIn');
  copyProperty(sourceItemRules, itemRule, 'allowContentOf');
  copyProperty(sourceItemRules, itemRule, 'allowWhere');
  copyProperty(sourceItemRules, itemRule, 'allowAttributes');
  copyProperty(sourceItemRules, itemRule, 'allowAttributesOf');
  copyProperty(sourceItemRules, itemRule, 'allowChildren');
  copyProperty(sourceItemRules, itemRule, 'inheritTypesFrom');
  makeInheritAllWork(sourceItemRules, itemRule);
  return itemRule;
}

function compileAllowChildren(compiledDefinitions, itemName) {
  var item = compiledDefinitions[itemName];

  var _iterator9 = _createForOfIteratorHelper(item.allowChildren),
      _step9;

  try {
    for (_iterator9.s(); !(_step9 = _iterator9.n()).done;) {
      var allowChildrenItem = _step9.value;
      var allowedChildren = compiledDefinitions[allowChildrenItem]; // The allowChildren property may point to an unregistered element.

      if (!allowedChildren) {
        continue;
      }

      allowedChildren.allowIn.push(itemName);
    } // The allowIn property already includes correct items, reset the allowChildren property
    // to avoid duplicates later when setting up compilation results.

  } catch (err) {
    _iterator9.e(err);
  } finally {
    _iterator9.f();
  }

  item.allowChildren.length = 0;
}

function compileAllowContentOf(compiledDefinitions, itemName) {
  var _iterator10 = _createForOfIteratorHelper(compiledDefinitions[itemName].allowContentOf),
      _step10;

  try {
    for (_iterator10.s(); !(_step10 = _iterator10.n()).done;) {
      var allowContentOfItemName = _step10.value;

      // The allowContentOf property may point to an unregistered element.
      if (compiledDefinitions[allowContentOfItemName]) {
        var allowedChildren = getAllowedChildren(compiledDefinitions, allowContentOfItemName);
        allowedChildren.forEach(function (allowedItem) {
          allowedItem.allowIn.push(itemName);
        });
      }
    }
  } catch (err) {
    _iterator10.e(err);
  } finally {
    _iterator10.f();
  }

  delete compiledDefinitions[itemName].allowContentOf;
}

function compileAllowWhere(compiledDefinitions, itemName) {
  var _iterator11 = _createForOfIteratorHelper(compiledDefinitions[itemName].allowWhere),
      _step11;

  try {
    for (_iterator11.s(); !(_step11 = _iterator11.n()).done;) {
      var allowWhereItemName = _step11.value;
      var inheritFrom = compiledDefinitions[allowWhereItemName]; // The allowWhere property may point to an unregistered element.

      if (inheritFrom) {
        var _compiledDefinitions$;

        var allowedIn = inheritFrom.allowIn;

        (_compiledDefinitions$ = compiledDefinitions[itemName].allowIn).push.apply(_compiledDefinitions$, _toConsumableArray(allowedIn));
      }
    }
  } catch (err) {
    _iterator11.e(err);
  } finally {
    _iterator11.f();
  }

  delete compiledDefinitions[itemName].allowWhere;
}

function compileAllowAttributesOf(compiledDefinitions, itemName) {
  var _iterator12 = _createForOfIteratorHelper(compiledDefinitions[itemName].allowAttributesOf),
      _step12;

  try {
    for (_iterator12.s(); !(_step12 = _iterator12.n()).done;) {
      var allowAttributeOfItem = _step12.value;
      var inheritFrom = compiledDefinitions[allowAttributeOfItem];

      if (inheritFrom) {
        var _compiledDefinitions$2;

        var inheritAttributes = inheritFrom.allowAttributes;

        (_compiledDefinitions$2 = compiledDefinitions[itemName].allowAttributes).push.apply(_compiledDefinitions$2, _toConsumableArray(inheritAttributes));
      }
    }
  } catch (err) {
    _iterator12.e(err);
  } finally {
    _iterator12.f();
  }

  delete compiledDefinitions[itemName].allowAttributesOf;
}

function compileInheritPropertiesFrom(compiledDefinitions, itemName) {
  var item = compiledDefinitions[itemName];

  var _iterator13 = _createForOfIteratorHelper(item.inheritTypesFrom),
      _step13;

  try {
    for (_iterator13.s(); !(_step13 = _iterator13.n()).done;) {
      var inheritPropertiesOfItem = _step13.value;
      var inheritFrom = compiledDefinitions[inheritPropertiesOfItem];

      if (inheritFrom) {
        var typeNames = Object.keys(inheritFrom).filter(function (name) {
          return name.startsWith('is');
        });

        var _iterator14 = _createForOfIteratorHelper(typeNames),
            _step14;

        try {
          for (_iterator14.s(); !(_step14 = _iterator14.n()).done;) {
            var name = _step14.value;

            if (!(name in item)) {
              item[name] = inheritFrom[name];
            }
          }
        } catch (err) {
          _iterator14.e(err);
        } finally {
          _iterator14.f();
        }
      }
    }
  } catch (err) {
    _iterator13.e(err);
  } finally {
    _iterator13.f();
  }

  delete item.inheritTypesFrom;
} // Remove items which weren't registered (because it may break some checks or we'd need to complicate them).
// Make sure allowIn doesn't contain repeated values.


function cleanUpAllowIn(compiledDefinitions, itemName) {
  var itemRule = compiledDefinitions[itemName];
  var existingItems = itemRule.allowIn.filter(function (itemToCheck) {
    return compiledDefinitions[itemToCheck];
  });
  itemRule.allowIn = Array.from(new Set(existingItems));
} // Setup allowChildren items based on allowIn.


function setupAllowChildren(compiledDefinitions, itemName) {
  var itemRule = compiledDefinitions[itemName];

  var _iterator15 = _createForOfIteratorHelper(itemRule.allowIn),
      _step15;

  try {
    for (_iterator15.s(); !(_step15 = _iterator15.n()).done;) {
      var allowedParentItemName = _step15.value;
      var allowedParentItem = compiledDefinitions[allowedParentItemName];
      allowedParentItem.allowChildren.push(itemName);
    }
  } catch (err) {
    _iterator15.e(err);
  } finally {
    _iterator15.f();
  }
}

function cleanUpAllowAttributes(compiledDefinitions, itemName) {
  var itemRule = compiledDefinitions[itemName];
  itemRule.allowAttributes = Array.from(new Set(itemRule.allowAttributes));
}

function copyTypes(sourceItemRules, itemRule) {
  var _iterator16 = _createForOfIteratorHelper(sourceItemRules),
      _step16;

  try {
    for (_iterator16.s(); !(_step16 = _iterator16.n()).done;) {
      var sourceItemRule = _step16.value;
      var typeNames = Object.keys(sourceItemRule).filter(function (name) {
        return name.startsWith('is');
      });

      var _iterator17 = _createForOfIteratorHelper(typeNames),
          _step17;

      try {
        for (_iterator17.s(); !(_step17 = _iterator17.n()).done;) {
          var name = _step17.value;
          itemRule[name] = sourceItemRule[name];
        }
      } catch (err) {
        _iterator17.e(err);
      } finally {
        _iterator17.f();
      }
    }
  } catch (err) {
    _iterator16.e(err);
  } finally {
    _iterator16.f();
  }
}

function copyProperty(sourceItemRules, itemRule, propertyName) {
  var _iterator18 = _createForOfIteratorHelper(sourceItemRules),
      _step18;

  try {
    for (_iterator18.s(); !(_step18 = _iterator18.n()).done;) {
      var sourceItemRule = _step18.value;

      if (typeof sourceItemRule[propertyName] == 'string') {
        itemRule[propertyName].push(sourceItemRule[propertyName]);
      } else if (Array.isArray(sourceItemRule[propertyName])) {
        var _itemRule$propertyNam;

        (_itemRule$propertyNam = itemRule[propertyName]).push.apply(_itemRule$propertyNam, _toConsumableArray(sourceItemRule[propertyName]));
      }
    }
  } catch (err) {
    _iterator18.e(err);
  } finally {
    _iterator18.f();
  }
}

function makeInheritAllWork(sourceItemRules, itemRule) {
  var _iterator19 = _createForOfIteratorHelper(sourceItemRules),
      _step19;

  try {
    for (_iterator19.s(); !(_step19 = _iterator19.n()).done;) {
      var sourceItemRule = _step19.value;
      var inheritFrom = sourceItemRule.inheritAllFrom;

      if (inheritFrom) {
        itemRule.allowContentOf.push(inheritFrom);
        itemRule.allowWhere.push(inheritFrom);
        itemRule.allowAttributesOf.push(inheritFrom);
        itemRule.inheritTypesFrom.push(inheritFrom);
      }
    }
  } catch (err) {
    _iterator19.e(err);
  } finally {
    _iterator19.f();
  }
}

function getAllowedChildren(compiledDefinitions, itemName) {
  var itemRule = compiledDefinitions[itemName];
  return getValues(compiledDefinitions).filter(function (def) {
    return def.allowIn.includes(itemRule.name);
  });
}

function getValues(obj) {
  return Object.keys(obj).map(function (key) {
    return obj[key];
  });
}

function mapContextItem(ctxItem) {
  if (typeof ctxItem == 'string' || ctxItem.is('documentFragment')) {
    return {
      name: typeof ctxItem == 'string' ? ctxItem : '$documentFragment',
      getAttributeKeys: function getAttributeKeys() {
        return /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
          return _regeneratorRuntime.wrap(function _callee$(_context4) {
            while (1) {
              switch (_context4.prev = _context4.next) {
                case 0:
                case "end":
                  return _context4.stop();
              }
            }
          }, _callee);
        })();
      },
      getAttribute: function getAttribute() {}
    };
  } else {
    return {
      // '$text' means text nodes and text proxies.
      name: ctxItem.is('element') ? ctxItem.name : '$text',
      getAttributeKeys: function getAttributeKeys() {
        return /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
          return _regeneratorRuntime.wrap(function _callee2$(_context5) {
            while (1) {
              switch (_context5.prev = _context5.next) {
                case 0:
                  return _context5.delegateYield(ctxItem.getAttributeKeys(), "t0", 1);

                case 1:
                case "end":
                  return _context5.stop();
              }
            }
          }, _callee2);
        })();
      },
      getAttribute: function getAttribute(key) {
        return ctxItem.getAttribute(key);
      }
    };
  }
} // Generator function returning values from provided walkers, switching between them at each iteration. If only one walker
// is provided it will return data only from that walker.
//
// @param {module:engine/module/treewalker~TreeWalker} [backward] Walker iterating in backward direction.
// @param {module:engine/module/treewalker~TreeWalker} [forward] Walker iterating in forward direction.
// @returns {Iterable.<Object>} Object returned at each iteration contains `value` and `walker` (informing which walker returned
// given value) fields.


function combineWalkers(backward, forward) {
  var done, step, _step20;

  return _regeneratorRuntime.wrap(function combineWalkers$(_context6) {
    while (1) {
      switch (_context6.prev = _context6.next) {
        case 0:
          done = false;

        case 1:
          if (done) {
            _context6.next = 17;
            break;
          }

          done = true;

          if (!backward) {
            _context6.next = 9;
            break;
          }

          step = backward.next();

          if (step.done) {
            _context6.next = 9;
            break;
          }

          done = false;
          _context6.next = 9;
          return {
            walker: backward,
            value: step.value
          };

        case 9:
          if (!forward) {
            _context6.next = 15;
            break;
          }

          _step20 = forward.next();

          if (_step20.done) {
            _context6.next = 15;
            break;
          }

          done = false;
          _context6.next = 15;
          return {
            walker: forward,
            value: _step20.value
          };

        case 15:
          _context6.next = 1;
          break;

        case 17:
        case "end":
          return _context6.stop();
      }
    }
  }, _marked);
} // Takes an array of non-intersecting ranges. For each of them gets minimal flat ranges covering that range and returns
// all those minimal flat ranges.
//
// @param {Array.<module:engine/model/range~Range>} ranges Ranges to process.
// @returns {Iterable.<module:engine/model/range~Range>} Minimal flat ranges of given `ranges`.


function convertToMinimalFlatRanges(ranges) {
  var _iterator20, _step21, range;

  return _regeneratorRuntime.wrap(function convertToMinimalFlatRanges$(_context7) {
    while (1) {
      switch (_context7.prev = _context7.next) {
        case 0:
          _iterator20 = _createForOfIteratorHelper(ranges);
          _context7.prev = 1;

          _iterator20.s();

        case 3:
          if ((_step21 = _iterator20.n()).done) {
            _context7.next = 8;
            break;
          }

          range = _step21.value;
          return _context7.delegateYield(range.getMinimalFlatRanges(), "t0", 6);

        case 6:
          _context7.next = 3;
          break;

        case 8:
          _context7.next = 13;
          break;

        case 10:
          _context7.prev = 10;
          _context7.t1 = _context7["catch"](1);

          _iterator20.e(_context7.t1);

        case 13:
          _context7.prev = 13;

          _iterator20.f();

          return _context7.finish(13);

        case 16:
        case "end":
          return _context7.stop();
      }
    }
  }, _marked2, null, [[1, 10, 13, 16]]);
}

function removeDisallowedAttributeFromNode(schema, node, writer) {
  var _iterator21 = _createForOfIteratorHelper(node.getAttributeKeys()),
      _step22;

  try {
    for (_iterator21.s(); !(_step22 = _iterator21.n()).done;) {
      var attribute = _step22.value;

      if (!schema.checkAttribute(node, attribute)) {
        writer.removeAttribute(attribute, node);
      }
    }
  } catch (err) {
    _iterator21.e(err);
  } finally {
    _iterator21.f();
  }
}